/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_ALL_RCA_LABELER_LIST = 'GET_ALL_RCA_LABELER_LIST';
export const NDC_SEARCH_BY_DRUG_NAME_TABLE_DATA = 'NDC_SEARCH_BY_DRUG_NAME_TABLE_DATA';
export const NDC_ERROR_POPUP_MESSAGE = 'NDC_ERROR_POPUP_MESSAGE';
export const NDC_LOADING = "NDC_LOADING";
export const NDC_DETAILS_TABLE_DATA = "NDC_DETAILS_TABLE_DATA";
export const NDC_DETAILS_TABLE_ROW_SELECTED = "NDC_DETAILS_TABLE_ROW_SELECTED";
export const GET_COMMON_DROPDOWN_DATA = "GET_COMMON_DROPDOWN_DATA";
export const GET_UC_NDC_BY_LABELLER = "GET_UC_NDC_BY_LABELLER";
export const GET_NDC_LIST_BY_LABELER = "GET_NDC_LIST_BY_LABELER";
export const ADD_REQUESTCLAIM_AUDIT = "ADD_REQUESTCLAIM_AUDIT";
export const REQUESTCLAIM_INPUT_VALUES = "REQUESTCLAIM_INPUT_VALUES";
export const LEFT_SIDE_TABLEDETAILS = "LEFT_SIDE_TABLEDETAILS";
export const RIGHT_SIDE_TABLEDETAILS = "RIGHT_SIDE_TABLEDETAILS";
export const REQUESTCLAIM_ERRORS = "REQUESTCLAIM_ERRORS";
export const DUPLICATE_ERRORS = "DUPLICATE_ERRORS";
export const CLEAR_PRELOADED_DATA = "CLEAR_PRELOADED_DATA";